import { Slider } from "@mui/material";
import {
  Box,
  CustomIconButton,
  MuiLoadingButton,
  CustomInput,
  SearchRounded,
  Typography,
} from "components/common";
import { useState } from "react";
import { ProductsLeftWrapper } from "./index.styled";

const minDistance = 10;

export default function LeftSideBar() {
  const [value, setValue] = useState<number[]>([10, 200]);
  const handleChange = (
    event: Event,
    newValue: number | number[],
    activeThumb: number
  ) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (activeThumb === 0) {
      setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
    } else {
      setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
    }
    // setValue(newValue as number[]);
  };
  return (
    <ProductsLeftWrapper>
      <Box>
        <CustomInput
          placeholder="Search Product"
          margin="none"
          InputProps={{
            endAdornment: (
              <CustomIconButton>
                <SearchRounded />
              </CustomIconButton>
            ),
          }}
        />
      </Box>
      <Box
        sx={{
          my: 3,
        }}
      >
        <Typography
          variant="subtitle2"
          fontSize="16px"
          fontWeight="700"
          gutterBottom
          whiteSpace="nowrap"
        >
          Filter by price
        </Typography>
        <Box
          sx={{
            width: "calc(100% - 20px)",
            margin: "auto",
          }}
        >
          <Slider
            getAriaLabel={() => "Temperature range"}
            value={value}
            onChange={handleChange}
            valueLabelDisplay="auto"
            disableSwap
            min={10}
            max={200}
            // getAriaValueText={valuetext}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="subtitle2"
            fontSize="16px"
            whiteSpace="nowrap"
            // sx={{ textWrap: "nowrap" }}
          >
            Price: ${value[0]} - ${value[1]}
          </Typography>
          <MuiLoadingButton size="small">Filter</MuiLoadingButton>
        </Box>
      </Box>
      <Typography
        variant="subtitle2"
        fontSize="16px"
        fontWeight="700"
        sx={{ textWrap: "nowrap" }}
      >
        Top Rated Products
      </Typography>
    </ProductsLeftWrapper>
  );
}
